import React, {useState, useEffect} from "react";
import { getTableColumMapping } from "../../../utils/manualDocuments/tableColumnsMappingForReturnType";
import ReactTable from "react-table";
import {connect} from "react-redux";
import Pagination from "../../page/Pagination";
import LanguageStringResolver from "../../fields/language/LanguageStringResolver";
import MANUAL_DOCUMENTS_CONTROLLER from "../../../controllers/manualDocuments";
import IntrastatForm from "./IntrastatForm";
import EcListingForm from "./EcListingForm";
import {ManualDocumentDocumentType} from "../../../utils/enums";
import {getLineTypeMappingLabelById} from "../../../utils/manualDocuments/lineListingTypeMappingForLabel";

const TabContainer = props => {
    const [formData, setFormData] = useState({data:[]});
    const [invoiceDate, setInvoiceDate] = useState(props.invoiceDate || "");
     
    // Update local state when props change
    useEffect(() => {
        if (props.invoiceDate) {
            setInvoiceDate(props.invoiceDate);
        }
    }, [props.invoiceDate]);
    
    useEffect(()=>{
        setFormData({data:[]})
    },[props.activeTab, invoiceDate]);

    const appendFormData = info => {
        const temp = formData.data;
        temp.push(info)
        setFormData({data: temp});
    }
    const onRowDeleteHandler = row => {
        if(row && row.index > -1) {
            let rows = [...formData.data];
            rows.splice(row.index, 1);
            setFormData({data: rows});
        }
    }
    const renderRemoveColumForEachRow = row => {
        return <a className="tertiary" data-testid="delete_row" href="#" onClick={() => onRowDeleteHandler(row)}><LanguageStringResolver string='manual_document_Remove'/></a>
    }

    const getCols = () => {
        const cols = getTableColumMapping(props.for)
        .filter(obj => {
            // Filter out columns based on feature flag condition
            if (!props.enableCoSGrid && 
                (obj.accessor === 'customerName' || 
                 obj.accessor === 'originalTradingPartnerVATNumber' || 
                 obj.accessor === 'originalTradingPartnerName' || 
                 obj.accessor === 'coSDate')) {
                return false;
            }
            return true;
        })
        .map(obj => {
            obj["Header"] = <span><LanguageStringResolver string={obj.header}/></span>
            return obj;
        })
        cols.push({
            Header: (<LanguageStringResolver string='manual_documents_formData_action_link' />),
            accessor: 'action',
            filterable: false,
            sortable: false,
            Cell: row => renderRemoveColumForEachRow(row)
        });
        return cols;
    }

    const onReset = () => {
        setFormData({data:[]});
    }

    const onSubmit = () => {
        let payload =  {
            "companyCode": props.selectedValues.companyCode,
            "country": props.selectedValues.country,
            "transactionDate": props.selectedValues.transactionDate,
            "invoiceDate": invoiceDate,  // Using the invoiceDate state variable here
            "reporterName": props.selectedValues.reporterName,
            "referenceCode": props.selectedValues.referenceCode,
            "currency": props.selectedValues.currency,
            "documentType": props.selectedValues.documentType === ManualDocumentDocumentType.SALES ? 0 : 1,
            "countryMainTransaction": props.selectedValues.country
        }
        if(props.for === "intrastat"){
            payload.filingType = 3;  // Vat = 1, Ec-listing = 2, Intrastat = 3
            payload["intrastatLines"] = formData.data;
        }
        else if (props.for === "ecListing" ){
            payload.filingType = 2;  // Vat = 1, Ec-listing = 2, Intrastat = 3
            payload["listingLines"] = formData.data;
        }
        props.doCreateManualDocumentLatest(payload);
        onReset();
    }

    const mappingToShowTextInTable = () => {
        const tableData = [];
        if(props.for === "intrastat") {
            formData.data.forEach(obj => {
                let temp = {...obj};
                temp["modeOfTransport"] = props.modeOfTransport.filter(f => f.value === obj["modeOfTransport"])[0]?.name;
                temp["deliveryCondition"] = props.deliveryConditions.filter(f => f.value === obj["deliveryCondition"])[0]?.name;
                temp["transactionType"] = props.transactionType.filter(f => f.value === obj["transactionType"])[0]?.name;
                tableData.push(temp);
            });
        }
        else if(props.for === "ecListing") {
            formData.data.forEach(obj => {
                obj.amount = Number(obj['amount']);
                let temp = {...obj};
                temp["listingType"] = obj["listingType"] === 0 ? "Sales" : "Purchase";
                temp["lineListingType"] = getLineTypeMappingLabelById(obj["lineListingType"]);
                tableData.push(temp);
            });
        }
        return tableData;
    }

    return (
        <s-container class="mb50 mt20" data-testid="intrastat-container">
            <div data-testid="intrastat-form-data-view">
                <ReactTable
                    manual
                    pages={1}
                    minRows={5}
                    defaultPageSize={5}
                    PaginationComponent={Pagination}
                    data={mappingToShowTextInTable()}
                    columns={getCols()}
                    showPageJump={true}
                    showPagination={formData.data.length > 0}
                    className={formData.data.length === 0 ? 'hide-header hide-footer' : ''}
                />
            </div>
            <button className="primary mt15" data-testid="submit-button" onClick={onSubmit} disabled={formData.data.length === 0 }>
                <LanguageStringResolver string='intrastat_manual_document_submit_button'/></button>
            <button className="secondary mt15" data-testid="formData-cancel-button" onClick={onReset} disabled={formData.data.length === 0 }>
                <LanguageStringResolver string='intrastat_manual_document_cancel_button'/></button>
            <hr data-testid="horizontal-rule-one"/>
            <div>
                {
                    props.for === "intrastat" &&
                    <IntrastatForm appendFormData={appendFormData} countryList={props.countryList}
                                   selectedValues={props.selectedValues} modeOfTransport={props.modeOfTransport} deliveryConditions={props.deliveryConditions} transactionType={props.transactionType}/>
                }
                {
                    props.for === "ecListing" &&
                    <EcListingForm appendFormData={appendFormData} countryList={props.countryList}
                                   selectedValues={props.selectedValues} listingLineType={props.listingLineType}
                                   invoiceDate={invoiceDate} setInvoiceDate={setInvoiceDate}/>
                }
            </div>
        </s-container>
    )
}
const mapStateToProps = (state) => {
    return {
        userName: (state.authentication && state.authentication.data && state.authentication.data.userName) || "Unknown",
        countryList : (state.content && state.content.contentData && state.content.contentData.countryList),
        modeOfTransport : (state.content && state.content.contentData && state.content.contentData.modeOfTransport),
        deliveryConditions : (state.content && state.content.contentData && state.content.contentData.deliveryConditions),
        transactionType : (state.content && state.content.contentData && state.content.contentData.transactionType),
        listingLineType : (state.content && state.content.contentData && state.content.contentData.listingLineType),
        enableCoSGrid: state.featureFlag?.data?.EnableCoSGrid
    };
}

const mapDispatchersToProps = (dispatch) => {
    return {
        doCreateManualDocumentLatest: (params, callback) => {
            dispatch(MANUAL_DOCUMENTS_CONTROLLER.doCreateManualDocumentLatest(params, callback))
        }
    }
}

export default connect(mapStateToProps, mapDispatchersToProps)(TabContainer);